import './PreviewImageAndClick.scss';
import { Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import lbCloseLight from '../../assets/images/common/lb-close-light.svg';
import lbNextPng from '../../assets/images/common/lb-next.svg';
import lbPrevPng from '../../assets/images/common/lb-prev.svg';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';

const PreviewImageAndClick = (props) => {
  const {
    previewImgOpen,
    previewImgToggle,
    selectImgIndex,
    selectImgIndexFun,
    imageList,
    needCount = false,
  } = props;

  const prevClick = () => {
    if (selectImgIndex === 0) {
      selectImgIndexFun(imageList.length - 1);
    } else {
      selectImgIndexFun(selectImgIndex - 1);
    }
  };

  const nextClick = () => {
    if (selectImgIndex === imageList.length - 1) {
      selectImgIndexFun(0);
    } else {
      selectImgIndexFun(selectImgIndex + 1);
    }
  };

  return (
    <Modal
      isOpen={previewImgOpen}
      toggle={previewImgToggle}
      modalClassName="preview-img-and-click"
      backdropClassName="preview-img-and-click-backdrop"
      returnFocusAfterClose={false}
    >
      <div className="title" onClick={previewImgToggle}>
        {/* <FontAwesomeIcon icon={faTimes} className="title-icon" /> */}
        <img src={lbCloseLight} className="close-icon" />
      </div>
      <div className="img-container">
        {imageList[selectImgIndex]?.video ? (
          <VideoPlayer src={imageList[selectImgIndex].video} loop is16than9={false} />
        ) : (
          <img src={imageList[selectImgIndex]?.image} onClick={nextClick} alt="error" />
        )}
        <img src={lbPrevPng} className="lb-prev" onClick={prevClick} />
        <img src={lbNextPng} className="lb-next" onClick={nextClick} />
      </div>
      {needCount && (
        <div className="img-count">
          {selectImgIndex + 1} of {imageList.length}
        </div>
      )}
    </Modal>
  );
};

export default PreviewImageAndClick;
